import React from 'react'
import { FieldHookConfig, useField, useFormikContext } from 'formik'
import { CustomSelect } from 'components'
import { genderIdentityKeys, genderIdentityList, biologicalSexKeys } from 'constants/gender'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import { useLocation } from 'react-router-dom'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormikCustomFieldProps = { className?: string; dataTestId?: string } & FieldHookConfig<any>

const biologicalSexByGener = {
    [genderIdentityKeys.HOMEM]: biologicalSexKeys.MASCULINO,
    [genderIdentityKeys.MULHER]: biologicalSexKeys.FEMININO,
    [genderIdentityKeys.HOMEM_TRANS]: biologicalSexKeys.FEMININO,
    [genderIdentityKeys.MULHER_TRANS]: biologicalSexKeys.MASCULINO,
    [genderIdentityKeys.NAO_BINARIO]: '',
}

export const FormikGenderCustomSelect = ({ className, dataTestId, ...props }: FormikCustomFieldProps) => {
    const [field, meta] = useField(props)
    const { setFieldValue } = useFormikContext()
    const { dispatchAnalyticsEvent } = useSignUpAnaytics()
    const { pathname } = useLocation()
    const nameEvent = (pathName: string) => {
        if (pathName === '/recuperar-senha') {
            return 'reset_password'
        }
        return 'cadastro_web'
    }

    const setBiologicalSexByGender = (gender: string) => {
        setFieldValue('biologicalSex', biologicalSexByGener[gender] || '')
    }

    const setEmptyWhenSocialName = (gender: string) =>
        [genderIdentityKeys.MULHER, genderIdentityKeys.HOMEM].includes(gender) && setFieldValue('socialName', '')

    const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // eslint-disable-next-line prefer-destructuring
        const { value } = e.target

        setBiologicalSexByGender(value)
        setEmptyWhenSocialName(value)
        field.onChange(e)
    }

    return (
        <CustomSelect
            data-testid={dataTestId}
            error={!!meta.touched && !!meta.error ? meta.error : ''}
            label="Identidade de gênero"
            name={props.name}
            onBlur={e => {
                field.onBlur(e)
                dispatchAnalyticsEvent('personalDataOnFieldBlur', {
                    name: nameEvent(pathname),
                    fieldName: e.target.name,
                    errorMessage: meta.error,
                })
            }}
            onChange={onChange}
            options={genderIdentityList}
            value={field.value}
        />
    )
}
